import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Embolcalla una secció i anima la seva entrada
export default function RevealSection({ id, children, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.2 });

  return (
    <section id={id} ref={ref} className={`relative scroll-mt-24 ${className}`} data-testid={`section-${id}`}>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.div>
    </section>
  );
}
